import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsRoleSetting({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M15.26 10.98c.07-.36.07-.73 0-1.08l.65-.38c.07-.04.1-.13.08-.22a3.82 3.82 0 00-.83-1.45.18.18 0 00-.22-.04l-.65.38a2.92 2.92 0 00-.92-.54v-.76a.18.18 0 00-.14-.18 3.72 3.72 0 00-1.66 0 .18.18 0 00-.14.18v.76c-.34.12-.65.3-.92.54l-.65-.38a.18.18 0 00-.22.04c-.38.4-.67.9-.83 1.45-.03.09 0 .18.08.22l.64.38c-.06.35-.06.72 0 1.08l-.64.38a.19.19 0 00-.08.21c.16.55.45 1.05.83 1.46.05.06.15.08.22.04l.65-.38c.27.23.58.42.92.54v.75c0 .1.06.17.14.18.56.13 1.13.13 1.66 0 .08-.01.14-.09.14-.18v-.75c.34-.12.65-.3.92-.54l.65.38c.07.04.16.02.22-.04.38-.41.66-.9.83-1.46a.19.19 0 00-.08-.21l-.65-.38zm-2.86.69c-.67 0-1.21-.55-1.21-1.23 0-.68.54-1.23 1.21-1.23.67 0 1.21.55 1.21 1.23 0 .68-.54 1.23-1.2 1.23zM5.6 8c1.77 0 3.2-1.45 3.2-3.25S7.37 1.5 5.6 1.5a3.23 3.23 0 00-3.2 3.25C2.4 6.55 3.83 8 5.6 8zm5.03 5.75l-.17-.1-.2.12a.99.99 0 01-.49.13.99.99 0 01-.72-.32c-.46-.5-.8-1.11-1-1.76a1 1 0 01.44-1.16l.2-.12v-.2l-.2-.12a1 1 0 01-.44-1.16l.08-.22c-.1 0-.2-.03-.29-.03h-.42a4.3 4.3 0 01-3.64 0h-.42A3.39 3.39 0 000 12.22v1.06c0 .67.54 1.22 1.2 1.22H10c.25 0 .49-.08.68-.22a1 1 0 01-.05-.3v-.23z" />
    </svg>
  );
}

SvgSettingsRoleSetting.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsRoleSetting.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgSettingsRoleSetting svgRef={ref} {...props} />
));
export default ForwardRef;
